/**
 * 絞り込みの選択肢を、表のセルのように格子を揃えて並べるための処理。
 *
 * 列幅を均等にしつつラベルを折り返さないためには「その項目で最も長い
 * ラベルの幅」が必要になるが、CSSでは文字幅を測れない。そこで一度だけ
 * 内容なりの幅にして計測し、結果を CSS 変数 --facet-col-min に渡す。
 *
 * あとは grid の auto-fill が、入る分だけ列を作ってくれる。
 * 幅が足りなければ列数が減るだけで、折り返しは起きない。
 *
 * PCのみ。スマホは1列なので計測不要。
 */
(() => {
  const DESKTOP = '(min-width: 750px)';
  const LIST_SELECTOR = '.facets__accordion .facets__list:not(.facets__list--slider-driven)';

  function measureColumnWidth(list) {
    /**
     * 内容なりの幅にしてから測る。
     *
     * 以前はCSSクラス(.is-measuring)の切り替えで対応していたが、
     * 既存の grid 指定と詳細度が同点になり、後勝ちの想定が崩れて
     * 実際には grid のままのことがあった(環境によって計測値が
     * コンテナ幅と同じ値になり、列が1つに潰れる不具合の原因)。
     *
     * インラインスタイルは詳細度の勝負に左右されないため、こちらで
     * 直接指定する。
     */
    const items = [...list.querySelectorAll('.facets__item')];
    const previousListDisplay = list.style.display;
    list.style.display = 'block';

    const previousItemStyles = items.map(item => item.style.width);
    items.forEach(item => { item.style.width = 'max-content'; });

    let widest = 0;
    items.forEach(item => {
      widest = Math.max(widest, item.getBoundingClientRect().width);
    });

    items.forEach((item, i) => { item.style.width = previousItemStyles[i]; });
    list.style.display = previousListDisplay;

    return Math.ceil(widest);
  }

  function layout(root = document) {
    const isDesktop = window.matchMedia(DESKTOP).matches;

    root.querySelectorAll(LIST_SELECTOR).forEach(list => {
      if (!isDesktop) {
        list.style.removeProperty('--facet-col-min');
        return;
      }

      const width = measureColumnWidth(list);
      if (width > 0) {
        list.style.setProperty('--facet-col-min', `${width}px`);
      }
    });
  }

  /** 検索結果の絞り込み後など、中身が差し替わったときにも測り直す */
  window.layoutFacetLists = layout;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => layout());
  } else {
    layout();
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => layout(), 200);
  });
})();
